import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hot",
  "use": "icon-hot-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-hot\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,23A7.5,7.5,0,0,1,6.86,10C8.2,8.77,11.5,6.5,11,1.5c6,4,9,8,3,14,1,0,2.5,0,5-2.47a7.49,7.49,0,0,1,.5,2.47A7.5,7.5,0,0,1,12,23Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol